
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-37d02fd3&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./LiftCallButtonDetail.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./LiftCallButtonDetail.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-37d02fd3!../../node_modules/vue-loader/lib/selector?type=template&index=0!./LiftCallButtonDetail.vue"),
  /* scopeId */
  "data-v-37d02fd3",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/LiftCallButtonDetail.vue
// module id = 276
// module chunks = 2 3